import { SearchBox } from "@transfr-inc/dashboard-components/forms";
import Skeleton from "react-loading-skeleton";
import { useAllMSA } from "../api";

export const MSADropdown = ({ selected, onChange, loading }) => {
  const { data, loading: allMsaLoading } = useAllMSA({ enabled: true });

  const onSearchTermChange = (term) => {
    // Handle empty selection which means unset the location
    if (!term) {
      onChange();
    }
  };

  if (loading) {
    return <Skeleton rounded height="32px" width="100%" />;
  }

  return (
    <SearchBox
      data={data}
      searchKey="name"
      showAllDataEnabled
      placeholder="Select an MSA"
      customOptionLabel={(msa) => msa?.name}
      disabled={allMsaLoading}
      onResultSelected={onChange}
      onSearchTermChange={onSearchTermChange}
      defaultOptionSelected={selected}
    />
  );
};
